<template>
    <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">All Notice</h1>
          </div><!-- /.col -->
          <div class="col-sm-6">
            <button class="btn btn-info float-right" @click="showCreateModal"><i class="fas fa-plus-circle"></i> Create</button>
          </div><!-- /.col -->
        </div><!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->
    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="name">Title</label>
                                    <input type="text" id="name" v-model="search.title" placeholder="Notice Title" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="type">Type</label>
                                    <v-select name="type"
                                        v-model="search.type"
                                        label="text"
                                        :reduce="item => item.id"
                                        :options= typeList
                                        :placeholder="$t('globalTrans.select')"
                                    />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="status">Type</label>
                                    <v-select name="status"
                                        v-model="search.status"
                                        label="text"
                                        :reduce="item => item.id"
                                        :options= statusList
                                        :placeholder="$t('globalTrans.select')"
                                    />
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="form-group">
                                    <button class="btn btn-info btn-sm mr-2" type="submit" @click.prevent="searchData" style="margin-top:28px;"><i class="fa fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <b-overlay :show="loader">
                            <div class="table-responsive">
                                <table class="table table-bordered table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th>SL</th>
                                            <th>Title</th>
                                            <th>Notice</th>
                                            <th>Type</th>
                                            <th>Status</th>
                                            <th style="text-align:center;">Action</th>
                                        </tr>
                                    </thead>
                                    <tfoot>
                                        <tr>
                                            <th>SL</th>
                                            <th>Title</th>
                                            <th>Notice</th>
                                            <th>Type</th>
                                            <th>Status</th>
                                            <th style="text-align:center;">Action</th>
                                        </tr>
                                    </tfoot>
                                    <tbody>
                                        <tr v-for="(item, index) in listData" :key="index">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ item.title }}</td>
                                            <td>{{ item.notice }}</td>
                                            <td>{{ getType(item.type) }}</td>
                                            <td :class="'notice-status-'+ item.status">{{ item.status == 1 ? 'On' : 'Off' }}</td>
                                            <td style="text-align:center;">
                                                <button class="btn btn-warning btn-sm mr-1" @click="editNotice(item)"><i class="fas fa-pencil-alt"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="mt-3">
                                <b-pagination
                                    v-model="pagination.currentPage"
                                    :per-page="pagination.perPage"
                                    :total-rows="pagination.totalRows"
                                    @input="searchData"
                                />
                            </div>
                        </b-overlay>
                    </div>
                </div>
            </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <div v-if="createModal" class="modal fade show" style="display:block" tabindex="-1" id="addHubModal" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <b-overlay :show="loader">
                    <div class="modal-header bg-info text-white">
                        <h5 class="modal-title text-center w-100">Create New Area</h5>
                        <button type="button" class="close" aria-label="Close" @click="cancelModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                            <form @submit.prevent="handleSubmit(saveForm)">
                                <div class="row">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <ValidationProvider name="Title" vid="title" v-slot="{errors}" rules="required">
                                            <div class="form-group">
                                                <label for="title">Title <span class="text-danger" title="Required">*</span></label>
                                                <input type="text" id="title" v-model="form.title" class="form-control" placeholder="Enter Title Name">
                                                 <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                   <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <ValidationProvider name="Notice" vid="notice" v-slot="{errors}" rules="required">
                                            <div class="form-group">
                                                <label for="notice">Notice <span class="text-danger" title="Required">*</span></label>
                                                <textarea class="form-control" v-model="form.notice" placeholder="Enter Notice Details"></textarea>
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <ValidationProvider name="Type" vid="type" v-slot="{errors}" rules="required|min_value:1">
                                            <div class="form-group">
                                                <label for="type">Type <span class="text-danger" title="Required">*</span></label>
                                                <v-select name="type"
                                                    v-model="form.type"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= typeList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <ValidationProvider name="Status" vid="status" v-slot="{errors}" rules="required|min_value:1">
                                            <div class="form-group">
                                                <label for="status">Status <span class="text-danger" title="Required">*</span></label>
                                                <v-select name="division_id"
                                                    v-model="form.status"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= statusList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-info" @click.prevent="saveForm">Save</button>
                        <button type="button" class="btn btn-danger" @click="cancelModal">Cancel</button>
                    </div>
                </b-overlay>
            </div>
        </div>
    </div>
    <div v-if="editModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <b-overlay :show="loader">
                    <div class="modal-header bg-info text-white">
                        <h5 class="modal-title text-center w-100">Edit Area</h5>
                        <button type="button" class="close" aria-label="Close" @click="cancelModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                         <ValidationObserver ref="editForm" v-slot="{ handleSubmit }">
                            <form @submit.prevent="handleSubmit(updateForm)">
                                <div class="row">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <ValidationProvider name="Title" vid="title" v-slot="{errors}" rules="required">
                                            <div class="form-group">
                                                <label for="title">Title <span class="text-danger" title="Required">*</span></label>
                                                <input type="text" id="title" v-model="form_edit.title" class="form-control" placeholder="Enter Title Name">
                                                 <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                   <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <ValidationProvider name="Notice" vid="notice" v-slot="{errors}" rules="required">
                                            <div class="form-group">
                                                <label for="notice">Notice <span class="text-danger" title="Required">*</span></label>
                                                <textarea class="form-control" v-model="form_edit.notice" placeholder="Enter Notice Details"></textarea>
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <ValidationProvider name="Type" vid="type" v-slot="{errors}" rules="required|min_value:1">
                                            <div class="form-group">
                                                <label for="type">Type <span class="text-danger" title="Required">*</span></label>
                                                <v-select name="type"
                                                    v-model="form_edit.type"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= typeList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <ValidationProvider name="Status" vid="status" v-slot="{errors}" rules="required|min_value:1">
                                            <div class="form-group">
                                                <label for="status">Status <span class="text-danger" title="Required">*</span></label>
                                                <v-select name="division_id"
                                                    v-model="form_edit.status"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= statusList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                                <span class="text-danger">{{ errors[0] }}</span>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-info" @click.prevent="updateForm">Update</button>
                        <button type="button" class="btn btn-danger" @click="cancelModal">Cancel</button>
                    </div>
                </b-overlay>
            </div>
        </div>
    </div>
    <div v-if="deleteModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-default" role="document">
            <div class="modal-content">
                <b-overlay :show="loader">
                    <div class="modal-header bg-info text-white">
                    <h5 class="modal-title text-center w-100">Delete Confirmation</h5>
                    </div>
                    <div class="modal-body">
                        <input type="hidden" name="del_id" />
                        <h3 class="text-center">Are you sure to delete ?</h3>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-info" @click="destroyArea">Delete</button>
                        <button type="button" class="btn btn-danger" @click="cancelModal">Cancel</button>
                    </div>
                </b-overlay>
            </div>
        </div>
    </div>  
    <!-- /.content -->
  </div>
</template>
<script>
import config from '@/config'
export default {
    name:'Notice',
    data(){
        return {
            loader: false,
            search: {
                title: '',
                type: '',
                status: ''
            },
            form:{
                title : '',
                notice: '',
                status: '',
                type: ''
            },
            form_edit:'',
            errors:[],
            createModal:false,
            editModal:false,
            deleteModal:false,
            statusList: [
                { id: 1, text: 'On' },
                { id: 2, text: 'Off' }
            ],
            key:'',
            pagination: {
                currentPage: 1,
                totalRows: 0,
                perPage: this.$store.state.commonObj.perPage,
                slOffset: 1
            },
            typeList: [
                {
                    id: 1,
                    text: 'Merchant'
                },
                {
                    id: 2,
                    text: 'Rider'
                },
                {
                    id: 3,
                    text: 'KAM/CSS'
                },
                {
                    id: 4,
                    text: 'Hub Manager'
                },
                {
                    id: 5,
                    text: 'Return Team'
                }
            ]
        }
    },
    created(){
        this.loadData()
    },
    watch: {
        stateReload : function (newVal, oldVal) {
            if (newVal != oldVal) {
                this.loadData()
            }
        }
    },
    computed : {
        stateReload () {
            return this.$store.state.stateReload
        },
        listData () {
            return this.$store.state.list
        }
    },
    methods:{
        searchData () {
            this.loadData()
        },
        async loadData(){     
            this.loader = true 
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })          
            const response = await config.getData('/notice', params)
            this.loader = false
            if (response.success){
                this.$store.dispatch('setList', response.data.data)
                this.paginationData(response.data)
            } else {
                this.$store.dispatch('setList', [])
            } 
        },
        paginationData (data) {
            this.pagination.currentPage = data.current_page
            this.pagination.totalRows = data.total
            this.pagination.perPage = data.per_page
            this.pagination.slOffset = this.pagination.perPage * this.pagination.currentPage - this.pagination.perPage + 1
        },
        getType(type) {
            if(type == 1) {
                return 'Merchant'
            } else if(type == 2) {
                return 'Rider'
            } else if(type == 3) {
                return 'Kam/CSS'
            } else if(type == 4) {
                return 'Hub Manager'
            } else if(type == 5) {
                return 'Return Team'
            }
        },
        showCreateModal(){
            this.createModal = true;
        },
        async saveForm(){
            this.loader = true
            this.$store.dispatch('stateReload', true)
            const response = await config.postData('/notice/store', this.form)
            this.loader = false
            if (response.success) {
                this.$store.dispatch('commonObjLoad', true)
                this.createModal = false;
                this.form.title = this.form.notice = this.form.status = ''          
                this.$toast.success({
                    title: 'Success',
                    message: 'Notice created successfully',
                    color: '#218838'
                }) 
            } else {
                this.$refs.form.setErrors(response.errors)
                this.$toast.error({
                    title: 'Error',
                    message: 'Sorry, something went wrong',
                    color: '#dc3545'
                })   
            }
            this.$store.dispatch('stateReload', false)
        },
        cancelModal(){
            this.createModal = false;
            this.editModal = false;
            this.deleteModal = false;
            this.form.title = this.form.notice = this.form.status = ''
        },
        editNotice(area){
            this.editModal = true;
            this.form_edit = area;
        },
        async updateForm(){
            this.loader = true
            this.$store.dispatch('stateReload', true)
            const response = await config.putData('/notice/update', this.form_edit)
            this.loader = false
            if (response.success) {
                this.$store.dispatch('commonObjLoad', true)
                this.editModal = false;            
                this.$toast.success({
                    title: 'Success',
                    message: 'Notice updated successfully',
                    color: '#218838'
                })  
            } else {
                this.$refs.editForm.setErrors(response.errors)
                this.$toast.error({
                    title: 'Error',
                    message: 'Sorry, something went wrong',                    
                    color: '#dc3545'
                })  
            }
            this.$store.dispatch('stateReload', false)
        }
    }
}
</script>